import { EXTENSION_ENV_KEYS } from "../extensions/definitions.js";

export const KITTY_BASE_ENV = {
  apiKey: "KITTY_API_KEY",
  provider: "KITTY_PROVIDER",
  baseUrl: "KITTY_BASE_URL",
  model: "KITTY_MODEL",
  profile: "KITTY_PROFILE",
  thinking: "KITTY_THINKING",
  reasoningEffort: "KITTY_REASONING_EFFORT",
  maxOutputTokens: "KITTY_MAX_OUTPUT_TOKENS",
  contextWindowMessages: "KITTY_CONTEXT_WINDOW_MESSAGES",
  maxContextChars: "KITTY_MAX_CONTEXT_CHARS",
  contextSummaryChars: "KITTY_CONTEXT_SUMMARY_CHARS",
  maxReadBytes: "KITTY_MAX_READ_BYTES",
  projectDocMaxBytes: "KITTY_PROJECT_DOC_MAX_BYTES",
  commandStallTimeoutMs: "KITTY_COMMAND_STALL_TIMEOUT_MS",
  showReasoning: "KITTY_SHOW_REASONING",
  telegramToken: "KITTY_TELEGRAM_TOKEN",
  telegramAllowedUserIds: "KITTY_TELEGRAM_ALLOWED_USER_IDS",
  telegramApiBaseUrl: "KITTY_TELEGRAM_API_BASE_URL",
  telegramProxyUrl: "KITTY_TELEGRAM_PROXY_URL",
  telegramPollingTimeoutSeconds: "KITTY_TELEGRAM_POLLING_TIMEOUT_SECONDS",
  telegramPollingLimit: "KITTY_TELEGRAM_POLLING_LIMIT",
  telegramPollingRetryBackoffMs: "KITTY_TELEGRAM_POLLING_RETRY_BACKOFF_MS",
  telegramMessageChunkChars: "KITTY_TELEGRAM_MESSAGE_CHUNK_CHARS",
  telegramTypingIntervalMs: "KITTY_TELEGRAM_TYPING_INTERVAL_MS",
  telegramDeliveryMaxRetries: "KITTY_TELEGRAM_DELIVERY_MAX_RETRIES",
  telegramDeliveryBaseDelayMs: "KITTY_TELEGRAM_DELIVERY_BASE_DELAY_MS",
  telegramDeliveryMaxDelayMs: "KITTY_TELEGRAM_DELIVERY_MAX_DELAY_MS",
} as const;

export const KITTY_ENV = {
  ...KITTY_BASE_ENV,
  extensions: EXTENSION_ENV_KEYS,
} as const;

export type KittyEnvKey = (typeof KITTY_BASE_ENV)[keyof typeof KITTY_BASE_ENV] | (typeof EXTENSION_ENV_KEYS)[keyof typeof EXTENSION_ENV_KEYS];
